export default function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}


//////////////////
// WEBPACK FOOTER
// ../@popperjs/core/lib/dom-utils/getWindow.js
// module id = 89
// module chunks = 22